<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import type { Attachment } from "@core/schema/Attachment.js";
	import { getUploadedFileExtension } from "@core/utils/getUploadedFileExtension.js";
	import { getUploadedFilePath } from "@core/utils/getUploadedFilePath.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import Link from "./common/Link.svelte";
	import { LinkVariant } from "./common/getLinkClass.js";

	const { attachments, class: customClass }: { attachments: Attachment[]; class?: ClassValue } = $props();

	const { FILE_BUCKET_URL_MAP } = getGlobalSettings();
</script>

{#if attachments.length > 0}
	<div class={["flex flex-wrap gap-4 text-md", customClass]}>
		{#each attachments as attachment (attachment.path)}
			{@const fileName = `${attachment.title}.${getUploadedFileExtension(attachment)}`}
			<Link
				variant={LinkVariant.Underline}
				href={getUploadedFilePath(attachment, FILE_BUCKET_URL_MAP)}
				download={fileName}
			>
				{fileName}
			</Link>
		{/each}
	</div>
{/if}
